import React, { useState, useEffect, useRef, useCallback } from "react";
import { Swiper } from "antd-mobile";

// 轮播组件
const BannerCarousel = ({ banners, onBannerClick,  ref }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timerRef = useRef(null);
  const isHovered = useRef(false);

  const goToNext = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % banners.length);
  }, [banners.length]);

  const startTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    if (!isHovered.current) {
      timerRef.current = setInterval(goToNext, 3000);
    }
  }, [goToNext]);
  useEffect(() => {
    startTimer();
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [banners.length, startTimer]);

  const handleMouseEnter = useCallback(() => {
    isHovered.current = true;
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);

  const handleMouseLeave = useCallback(() => {
    isHovered.current = false;
    startTimer();
  }, [startTimer]);

  const handleTouchStart = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);

  const handleTouchEnd = useCallback(() => {
    if (!isHovered.current) {
      startTimer();
    }
  }, [startTimer]);

  const bannerItems = banners.map((banner, index) => (
    <Swiper.Item key={index}>
      <div 
        onClick={() => onBannerClick(banner)}
        style={{ width: '100%', height: '100%' }}
      >
        <img 
          src={banner.url} 
          alt={`轮播图${index + 1}`} 
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
    </Swiper.Item>
  ));

  if (banners.length === 0) return null;

  return (
    <div className="banner-container"
      ref={ref}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      // style={{ width: '100%' }}
    >
      <Swiper
        loop
        autoplay
        current={currentIndex}
        onIndexChange={setCurrentIndex}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        style={{ "--height": "180px" }}
      >
        {bannerItems}
      </Swiper>
      <div style={{ 
    background: 'linear-gradient(87.2552581597116deg, #caf982 0%, #70b603 146%)',
    height: '6px'}}></div>
    </div>
  );
};

export default BannerCarousel;